import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Modal, Typography, TextField, Stack } from "@mui/material";

import { Button, Alert } from "../../../common/styled";
import ModalBox from "../../../../common/ModalBox";

import useLLMConfig from "../../../../../hooks/user/useLLMConfig";

function URLReachabilityModal({ open, handleClose, zoneUid }) {
  const { llmOutputScanners, configLLMSettingOutputScanners } = useLLMConfig();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        timeout: llmOutputScanners ? llmOutputScanners?.url_reachabitlity?.timeout : 0,
      }}
      validationSchema={Yup.object().shape({
        timeout: Yup.number().integer('Timeout must be an integer').min(0, "Timeout must be at least 0"),
      })}
      onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        try {
          values.submit = undefined;
          await configLLMSettingOutputScanners(zoneUid, "url_reachabitlity", values);
          handleClose();
          resetForm();
        } catch (error) {
          const message = error.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => (
        <React.Fragment>
          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
          >
            <ModalBox sx={{ width: "60vw" }} title="Edit URL Reachability Scanner" handleClose={handleClose}>
              <form noValidate onSubmit={handleSubmit}>
                <Grid container p={4} spacing={3}>
                  <Grid item xs={12}>
                    {errors.submit && (
                      <Alert mt={2} mb={3} variant="outlined" severity="error">
                        {errors.submit}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Timeout</Typography>
                      <TextField
                        fullWidth
                        name="timeout"
                        type="number"
                        error={Boolean(touched.timeout && errors.timeout)}
                        helperText={touched.timeout && errors.timeout}
                        value={values.timeout}
                        onBlur={(e) => {
                          if (e.target.value === "") setFieldValue("timeout", 0);
                        }}
                        onChange={handleChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} textAlign={"right"} pt={4}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                      <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained" color="success" size="modal" disabled={isSubmitting}>
                        Save
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </form>
            </ModalBox>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default URLReachabilityModal;
